import Component from 'core/Component';
import { deepMerge } from 'toolbox/deepMerge';
import { Event } from 'services/EventEmitter';

/**
 * This is a description of the BazaarvoiceReviews constructor function.
 * @class
 * @classdesc This is a description of the BazaarvoiceReviews class
 * @extends Component
 */
export default class BazaarvoiceService extends Component {
    /**
     * Constructor of the class that mainly merge the options of the components
     * @param {HTMLElement} element HTMLElement of the component
     * @param {Object} options options that belongs to the component
     */
    constructor(element, options = {}) {
        super(element, deepMerge({
            productID: null,
        }, options));
    }

    /**
     * Should contain only event listeners and nothing else
     * All the event handlers should be into a separated function. No usage of anonyous function
     */
    bindEvents() {
        Event.once('BV.dependency.check', this.afterInit, this);
    }

    /**
     * After init
     * Run any script after the component is fully initialized
     */
    afterInit() {
        this.loadService();
        Event.emit('BV.dependency.loaded');
    }

    /**
     * Set product ID to load Bazaarvoice on demand
     */
    loadService() {
        if (this.options.productID) {
            const elementType = this.element.getAttribute('data-element-type');
            if (elementType) {
                this.element.setAttribute('data-bv-show', elementType);
                this.element.setAttribute('data-bv-product-id', this.options.productID);
            }
        }
        if ('bvUserToken' in this.options && this.options.bvUserToken) {
            const meta = document.createElement('meta');
            meta.name = 'bv:userToken';
            meta.content = this.options.bvUserToken;
            document.getElementsByTagName('head')[0].appendChild(meta);
        }
    }

    /**
     * Destroy is called automatically after the component is being removed from the DOM
     * You must always destroy the listeners attached to an element to avoid any memory leaks
     */
    destroy() {
        Event.removeListener('BV.dependency.check', this.afterInit, this);
    }
}
